/* global fetch */

import { config } from '../config';
import { headers, APIResponse, stleaf, fetchAPI, SpanTag } from '../helpers';

export enum FeatureFlagNames {
  VolumetricRequest = 'volumetric-request',
  PowercorInspectionDashboard = 'powercor-inspection-dashboard',
  ManageUsers = 'manage-users',
  ThreeDViewer = '3d-viewer', // TODO: deprecate this as no longer used - see plan based features
  CustomBranding = 'custom-branding', // TODO: deprecate this as no longer used - see plan based features
  MultipleWorkspaces = 'multiple-workspaces', // TODO: deprecate this as no longer used - see plan based features
  GigapixelCalculator = 'gigapixel-calculator',
  Sites = 'sites',
  /** New standalone Sites feature (map_site* entity). Separate from the legacy
      mission-era `sites` flag above; off by default until toggled per-org. */
  ReferenceSets = 'reference-sets',
  AnnotationReports = 'annotation-reports',
  MapsV2 = 'maps-v2',
  Missions = 'missions', // Controls access to Original Birdi Maps
  DemContours = 'dem-contours',
  DemHillshade = 'dem-hillshade',
  AiDetectMediaObjectRemoval = 'ai-detect-media-object-removal',
  SplatViewer = 'splat-viewer', // Gates the Gaussian-splat renderer mode + switcher-bar entry
  GlobalSearch = 'global-search', // DEPRECATED 2026-10-06: Global Search is on for all orgs; rows inert
  TransformerV3 = 'transformer-v3', // DEPRECATED 2026-07-23: v3 is default-on; rows inert
  /** TEMPORARY (BIR-22). Staged-rollout gate for site-sourced GCP/prism points
      in the processing form. Sits in front of the `gcp-processing` /
      `prism-processing` plan features; removed once the flow ships broadly. */
  SitesGcpPrismProcessing = 'sites-gcp-prism-processing',
  Scene3dView = 'scene-3d-view', // DEPRECATED 2026-10-30: scene3d is the 3D view for all orgs; rows inert
  PicToPoint = 'pic-to-point', // DEPRECATED 2026-11-02: pic to point is on for all orgs; rows inert
}

export const getByName = (
  st: SpanTag,
  featureName: FeatureFlagNames,
): Promise<APIResponse> => {
  const url = `${config.API_URL}/v1/features/organisation/${featureName}`;
  return fetchAPI(stleaf(st, 'sha8ir'), url, {
    method: 'GET',
    credentials: 'include',
    headers,
  });
};

export const getAll = (st: SpanTag): Promise<APIResponse> => {
  const url = `${config.API_URL}/v1/features/organisation`;

  return fetchAPI(stleaf(st, 'oot1fi'), url, {
    method: 'GET',
    credentials: 'include',
    headers: headers,
  });
};
